import cn from 'classnames';

import ChiliPepper from 'components/icons/illustrative/ChiliPepper';
import { shouldShowMealTitleSpiceIcon, normalizeMealTitle } from 'helpers/mealDisplay';
import { ICON_SIZES } from 'lib/constants/iconSizes';

const MealCardTitle = ({
  as: TitleElement = 'p',
  meal: { title, subtitle, spiceLevel },
  mealPlanSlug,
  showSubtitle = true,
  titleClassName = '',
  subtitleClassName = '',
  iconStyles = 'inline-block align-top',
}) => {
  const shouldShowSpicyIcon = shouldShowMealTitleSpiceIcon({ spiceLevel, mealPlanSlug });

  return (
    <>
      <TitleElement className={cn(titleClassName || 'h6')} data-testid="meal-card-title">
        {shouldShowSpicyIcon && (
          <ChiliPepper className={iconStyles} isFilledRed svgSize={ICON_SIZES.SM} />
        )}
        {normalizeMealTitle(title)}
      </TitleElement>
      {showSubtitle && subtitle && (
        <p className={cn('text mb-2 text-charcoal-90', subtitleClassName)}>{subtitle}</p>
      )}
    </>
  );
};

MealCardTitle.propTypes = {
  as: PropTypes.elementType,
  meal: PropTypes.shape({
    spiceLevel: PropTypes.string,
    subtitle: PropTypes.string,
    title: PropTypes.string.isRequired,
  }).isRequired,
  iconStyles: PropTypes.string,
  mealPlanSlug: PropTypes.string,
  showSubtitle: PropTypes.bool,
  titleClassName: PropTypes.string,
  subtitleClassName: PropTypes.string,
};

export default MealCardTitle;
